import { useEffect, useState, Fragment } from "react";
import { mail, newMail } from "../../util/icon";
import { useDispatch, useSelector } from "react-redux";
import {
  getNewSmsFetch,
  postReadSmsFetch,
} from "../../features/action/fetchSMS";
import { SmsItem } from "./SmsItem";
import { putStatusComment } from "../../features/action/fetchStatus";
import { FaArrowRight } from "react-icons/fa";

export const SmsPanel = ({ isUser }) => {
  const { sms } = useSelector((state) => state.sms);
  const dispatch = useDispatch();
   
  const [isMailOpen, setIsMailOpen] = useState(false);
  const [hasNewSms, setHasNewSms] = useState(false);
  const [openSms, setOpenSms] = useState({});
  const [comment, setComment] = useState("");

  useEffect(() => {
    if (!isUser) return;
    if (sms?.some((item) => !item.readBy?.includes(isUser.username))) {
      setHasNewSms(true);
    } else {
      setHasNewSms(false);
    }
  }, [sms, isUser]);

  useEffect(() => {
    dispatch(getNewSmsFetch());
  }, [dispatch]);

  if (!isUser) return null;
   
   const toggleSms = (order) => {
    setOpenSms((prev) => {
     if (prev[order]) {
       return {};
     }
     return { [order]: true };
   });
   };
 
   const handlePushComment = (e, status_id, comment) => {
     e.stopPropagation();
     dispatch(putStatusComment(status_id, comment, isUser.username));
     setComment("");
   };
 
   const handleReadSms = () => {
   if (isMailOpen) {
     dispatch(postReadSmsFetch(isUser.username));
   } else {
     setHasNewSms(false);
   }
   setIsMailOpen(!isMailOpen);
 };

  return (
    <div className="relative">
         <div className="cursor-pointer" onClick={handleReadSms}>
           {hasNewSms ? newMail : mail}
         </div>
         <div
           className={`fixed top-[90px] right-0 h-auto  bg-white/60 backdrop-blur-md border border-white/30 shadow-2xl z-40 transform transition-transform duration-300 ease-in-out overflow-y-auto rounded-md  ${
             isMailOpen ? "translate-x-0" : "translate-x-full"
           }`}
         >
           <div className="flex flex-col p-4 ">
             {sms.map((item, index) => (
              <Fragment key={index}>
                <SmsItem
                  isUser={isUser}
                  item={item}
                  onToggle={() => toggleSms(item.order)}
                />
                {openSms[item.order] && (
                  <div className="p-3 bg-blue-50  ">
                    <p className="text-sm font-semibold mb-2 text-[#7D7D7D]">Comments:</p>
                    {item.comment.map((comment, index) => (
                      <div
                        key={index}
                        className="text-xs text-[#7D7D7D] mb-1 p-2 bg-white rounded"
                      >
                        {comment}
                      </div>
                    ))}
                    <input
                      type="text"
                      className=" h-[40px] w-[80%] px-2 m-2 border-solid border-[1px] border-[#D9D9D9] outline-none rounded-[10px]  "
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <button
                      className="w-[13%] h-[40px] rounded-lg  border-[1px] border-[#D9D9D9]"
                      onClick={(e) => handlePushComment(e,item.status_id, comment)}
                    >
                      <FaArrowRight className="text-[30px] text-[#739D00] font-bold hover:text-[#739d00a8] " />
                    </button>
                  </div>
                )}
              </Fragment>
            ))}
           </div>
         </div>
       </div>
  );
};